<form [formGroup]="viewForm" (ngSubmit)="onSubmit(model)" *ngIf="!editOnly" class="view-form">
	<div class="row">
		<div class="col-xs-12">
			<formly-form [form]="viewForm" [fields]="_fields" [model]="model" [options]="options"></formly-form>
		</div>
	</div>
	<div class="row">
		<div class="col-xs-12">
			<ng-content></ng-content>
		</div>
	</div>
</form>

<!-- Edit Templates -->
<!-- Flyout -->
<ng-template #flyoutTemplate let-form="form" let-fields="fields" let-model="model" let-options="options">
	<div class="linq-drawer-content">
		<header class="linq-drawer-header">
			<h3 class="linq-heading">{{ calculatedFlyoutTitle }}</h3>
			<button class="linq-drawer-header__close linq-button-close-lg" (click)="closeFlyout()">
				<mat-icon>clear</mat-icon>
			</button>
		</header>
		<form [formGroup]="form" (ngSubmit)="onSubmit(model)" class="linq-drawer-form-content">
			<div class="linq-drawer-inner-content">
				<formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
			</div>
			<mat-toolbar class="linq-drawer-footer">
				<button class="linq-button linq-button--secondary" type="button" mat-stroked-button color="primary"
					(click)="closeFlyout()">{{cancelButtonText}}</button>
				<span class="spacer" *ngIf="actionButtons.length === 0"></span>
				<ng-content select="[secondButton]"></ng-content>
				<div *ngFor="let button of actionButtons; key: 'label'">
					<button (click)="button.onClick($event)" [attr.aria-label]="button.ariaLabel || button.label" mat-raised-button color="primary"
						type="button" class="linq-button-text" [ngClass]="button.cssClass" [disabled]="button.disabled && button.disabled()">
						<mat-icon *ngIf="button.icon">{{ button.icon }}</mat-icon>
						{{ button.label }}
					</button>
				</div>
				<button class="linq-button linq-button--primary" *ngIf="!hideSaveButton"
					[disabled]="form.invalid || form.pending || !form.dirty || options.formState?.disabled" type="submit" mat-raised-button
					color="primary" class="pull-right">{{confirmButtonText}}</button>
			</mat-toolbar>
		</form>
	</div>
</ng-template>
